import React from 'react';
import { connect } from 'react-redux';
import GenericFormField from '../../../../../generic/GenericFormField';
import { contentTypes } from '../../../../../../constants';
import { setDefaultContentValue } from '../../../../../../actions/reduxActions/valueEditor';
import '../../../../../../../css/value-editor.less';

/**
 * Collect a primitive default value
 *
 * @param {Object} value the current value
 * @param {Function} handleDefaultContentValue handler to set the default value
 */
export const ValueEditorPrimitive = ({ value, handleDefaultContentValue }) => (

    <GenericFormField
        value={value.defaultContentValue || ''}
        type={value.contentType}
        onChange={e => handleDefaultContentValue(e.target)}
        label={value.contentType.toUpperCase() === contentTypes.boolean ? 'Default value' : ''}
        placeholder="A default applied to this Value"
        isRequired={false}
    />
);

const mapDispatchToProps = {
    handleDefaultContentValue: setDefaultContentValue,
};

export default connect(
    null,
    mapDispatchToProps,
)(ValueEditorPrimitive);
